import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

// find displayText on area view
export function getPrefectureDisplayName(
  selectedPrefecture: string,
  prefectureList: PortalAdapterApi.ResponseGetTopAreaList,
): string | undefined {
  return prefectureList.find((prefecture) => prefecture.areaGroupName === selectedPrefecture)?.displayText;
}
